<app-page-header [options]="options" (optionSelected)="optionSelected($event)"></app-page-header>
<div class="row" id="entireScreen">
  <div class="col-12">
    <app-storage-report-duplicate-files-table
      *ngIf="storageReport?.status?.name != ''"
      (filesEvent)="receiveFilesEvent($event)"
      [storageReport]="storageReport"
      [fixDuplicateBanner]="fixDuplicateBanner"
      [options]="options"
    >
    </app-storage-report-duplicate-files-table>
  </div>
</div>
